import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { SchadenmeldungUploadDatenExtendedApi } from './SchadenmeldungSchadenmeldungUploadDatenExtendedApi';
import { SchadenmeldungUploadDatenApi } from './SchadenmeldungSchadenmeldungUploadDatenApi';

/**
 * APIL Url: ADAC.Internet.Core.Models.Schadenmeldung.Aks.SchadenAksDokumente
 * Sammlung  aller Dokumente mit Kosten
 * Endpoints: /api/schadenmeldungen/aks
 */
export class SchadenAksDokumenteApi extends BaseApiModel {
	constructor(initialProperties?: Partial<SchadenAksDokumenteApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected dokBehandlungskosten: SchadenmeldungUploadDatenExtendedApi[];
	/**
	 * Description: Liste aller Dokumente für Behandlungskosten
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungUploadDatenExtended>
	 */
	get DokBehandlungskosten(): SchadenmeldungUploadDatenExtendedApi[] {
		return this.dokBehandlungskosten;
	}

	/**
	 * Description: Liste aller Dokumente für Behandlungskosten
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungUploadDatenExtended>
	 */
	set DokBehandlungskosten(value: SchadenmeldungUploadDatenExtendedApi[]) {
		this.dokBehandlungskosten = value;
	}

	protected dokMedikamente: SchadenmeldungUploadDatenExtendedApi[];
	/**
	 * Description: Liste aller Dokumente für Medikamente
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungUploadDatenExtended>
	 */
	get DokMedikamente(): SchadenmeldungUploadDatenExtendedApi[] {
		return this.dokMedikamente;
	}

	/**
	 * Description: Liste aller Dokumente für Medikamente
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungUploadDatenExtended>
	 */
	set DokMedikamente(value: SchadenmeldungUploadDatenExtendedApi[]) {
		this.dokMedikamente = value;
	}

	protected dokPatiententransport: SchadenmeldungUploadDatenExtendedApi[];
	/**
	 * Description: Liste aller Dokumente für Patiententransport
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungUploadDatenExtended>
	 */
	get DokPatiententransport(): SchadenmeldungUploadDatenExtendedApi[] {
		return this.dokPatiententransport;
	}

	/**
	 * Description: Liste aller Dokumente für Patiententransport
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungUploadDatenExtended>
	 */
	set DokPatiententransport(value: SchadenmeldungUploadDatenExtendedApi[]) {
		this.dokPatiententransport = value;
	}

	protected dokSonstige: SchadenmeldungUploadDatenExtendedApi[];
	/**
	 * Description: Liste aller sonstigen Dokumente
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungUploadDatenExtended>
	 */
	get DokSonstige(): SchadenmeldungUploadDatenExtendedApi[] {
		return this.dokSonstige;
	}

	/**
	 * Description: Liste aller sonstigen Dokumente
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungUploadDatenExtended>
	 */
	set DokSonstige(value: SchadenmeldungUploadDatenExtendedApi[]) {
		this.dokSonstige = value;
	}

	protected dokNachweisBelege: SchadenmeldungUploadDatenApi[];
	/**
	 * Description: Liste aller Belege zum Nachweis von z. B. Diagnose, Befund, Rechnung, Arztbericht, Behandlungsvertrag etc.
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungUploadDaten>
	 */
	get DokNachweisBelege(): SchadenmeldungUploadDatenApi[] {
		return this.dokNachweisBelege;
	}

	/**
	 * Description: Liste aller Belege zum Nachweis von z. B. Diagnose, Befund, Rechnung, Arztbericht, Behandlungsvertrag etc.
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungUploadDaten>
	 */
	set DokNachweisBelege(value: SchadenmeldungUploadDatenApi[]) {
		this.dokNachweisBelege = value;
	}

	protected dokAbreiseDeutschland: SchadenmeldungUploadDatenApi[];
	/**
	 * Description: Liste aller Belege zum Nachweis der Abreise nach Deutschland
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungUploadDaten>
	 */
	get DokAbreiseDeutschland(): SchadenmeldungUploadDatenApi[] {
		return this.dokAbreiseDeutschland;
	}

	/**
	 * Description: Liste aller Belege zum Nachweis der Abreise nach Deutschland
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungUploadDaten>
	 */
	set DokAbreiseDeutschland(value: SchadenmeldungUploadDatenApi[]) {
		this.dokAbreiseDeutschland = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): SchadenAksDokumenteApi {
		return AppUtils.Helper.createFromMap(dataObject, SchadenAksDokumenteApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'dokbehandlungskosten':
					const resultdokbehandlungskosten = new Array<SchadenmeldungUploadDatenExtendedApi>();
					if (value && Array.isArray(value)) {
						value.forEach((v: any) => {
							resultdokbehandlungskosten.push(SchadenmeldungUploadDatenExtendedApi.createFromObject(v));
						});
					}
					return resultdokbehandlungskosten;
				case 'dokmedikamente':
					const resultdokmedikamente = new Array<SchadenmeldungUploadDatenExtendedApi>();
					if (value && Array.isArray(value)) {
						value.forEach((v: any) => {
							resultdokmedikamente.push(SchadenmeldungUploadDatenExtendedApi.createFromObject(v));
						});
					}
					return resultdokmedikamente;
				case 'dokpatiententransport':
					const resultdokpatiententransport = new Array<SchadenmeldungUploadDatenExtendedApi>();
					if (value && Array.isArray(value)) {
						value.forEach((v: any) => {
							resultdokpatiententransport.push(SchadenmeldungUploadDatenExtendedApi.createFromObject(v));
						});
					}
					return resultdokpatiententransport;
				case 'doksonstige':
					const resultdoksonstige = new Array<SchadenmeldungUploadDatenExtendedApi>();
					if (value && Array.isArray(value)) {
						value.forEach((v: any) => {
							resultdoksonstige.push(SchadenmeldungUploadDatenExtendedApi.createFromObject(v));
						});
					}
					return resultdoksonstige;
				case 'doknachweisbelege':
					const resultdoknachweisbelege = new Array<SchadenmeldungUploadDatenApi>();
					if (value && Array.isArray(value)) {
						value.forEach((v: any) => {
							resultdoknachweisbelege.push(SchadenmeldungUploadDatenApi.createFromObject(v));
						});
					}
					return resultdoknachweisbelege;
				case 'dokabreisedeutschland':
					const resultdokabreisedeutschland = new Array<SchadenmeldungUploadDatenApi>();
					if (value && Array.isArray(value)) {
						value.forEach((v: any) => {
							resultdokabreisedeutschland.push(SchadenmeldungUploadDatenApi.createFromObject(v));
						});
					}
					return resultdokabreisedeutschland;
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		const dokBehandlungskostenArrayReqObject: object[] = [];
		this.dokBehandlungskosten.forEach((element) => {
			dokBehandlungskostenArrayReqObject.push(element.toRequestObject());
		});
		result.DokBehandlungskosten = dokBehandlungskostenArrayReqObject;
		const dokMedikamenteArrayReqObject: object[] = [];
		this.dokMedikamente.forEach((element) => {
			dokMedikamenteArrayReqObject.push(element.toRequestObject());
		});
		result.DokMedikamente = dokMedikamenteArrayReqObject;
		const dokPatiententransportArrayReqObject: object[] = [];
		this.dokPatiententransport.forEach((element) => {
			dokPatiententransportArrayReqObject.push(element.toRequestObject());
		});
		result.DokPatiententransport = dokPatiententransportArrayReqObject;
		const dokSonstigeArrayReqObject: object[] = [];
		this.dokSonstige.forEach((element) => {
			dokSonstigeArrayReqObject.push(element.toRequestObject());
		});
		result.DokSonstige = dokSonstigeArrayReqObject;
		const dokNachweisBelegeArrayReqObject: object[] = [];
		this.dokNachweisBelege.forEach((element) => {
			dokNachweisBelegeArrayReqObject.push(element.toRequestObject());
		});
		result.DokNachweisBelege = dokNachweisBelegeArrayReqObject;
		const dokAbreiseDeutschlandArrayReqObject: object[] = [];
		this.dokAbreiseDeutschland.forEach((element) => {
			dokAbreiseDeutschlandArrayReqObject.push(element.toRequestObject());
		});
		result.DokAbreiseDeutschland = dokAbreiseDeutschlandArrayReqObject;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}